<template>
  <div class="flex gap-1" role="group" aria-label="Bewertung">
    <button
      v-for="v in values"
      :key="v"
      type="button"
      class="w-10 h-9 rounded-md flex items-center justify-center text-sm font-semibold border transition
             focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-indigo-500"
      :class="buttonClass(v)"
      :aria-pressed="modelValue === v ? 'true' : 'false'"
      :title="kuerzel(v)"
      @click="$emit('update:modelValue', v)"
    >
      {{ v > 0 ? '+' + v : v }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: Number, default: 0 },
  },
  emits: ["update:modelValue"],
  computed: {
    // Die Skala ist die des aktiven Prompts. Sie ist hier bewusst hart
    // hinterlegt und nicht konfigurierbar: seit dem Wegfall des freien
    // Zahlenfelds ist diese Liste die EINZIGE Stelle, an der ein Wert gesetzt
    // werden kann -- ein Wert ausserhalb waere danach weder darstellbar noch
    // korrigierbar.
    values() {
      return [-3, -2, -1, 0, 1, 2, 3];
    },
  },
  methods: {
    buttonClass(v) {
      if (this.modelValue === v) {
        return "bg-indigo-600 text-white border-indigo-600";
      }
      if (v < 0) return "bg-white text-red-700 border-gray-300 hover:bg-red-50 hover:border-red-300";
      if (v > 0) return "bg-white text-green-700 border-gray-300 hover:bg-green-50 hover:border-green-300";
      return "bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:border-gray-400";
    },

    kuerzel(v) {
      if (v === 0) return "Wert 0 - Taste 0";
      if (v > 0) return `Wert +${v} - Taste ${v}`;
      return `Wert ${v} - Shift+${Math.abs(v)}`;
    },
  },
};
</script>
